'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FurnaceIcon = function FurnaceIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M35 78h59v37H35zM35.15 38.7l28.13-21.775h3.475l13.961 10.08v-9.038h9.354v16.87l4.682 3.863V72H35.15z'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M15 74h100v-2H15zM15 79h100v-2H15z'
                })
            ),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555',
                    fillRule: 'nonzero'
                },
                _react2.default.createElement('path', {
                    d: 'M101.398 44.976L67.376 18.202c-1.61-1.265-4.066-1.265-5.675 0L27.167 45.379l-1.39-1.81.499-.394 34.022-26.772c2.42-1.907 6.06-1.907 8.478 0L103.3 43.567l-1.39 1.81-.512-.402z'
                }),
                _react2.default.createElement('path', {
                    d: 'M93.054 72.723v-35.29h2.275v35.29h-2.275zm1.286-34.349l-.149-.149-.149.15v.345h.298v-.346zM33.747 72.723v-35.29h2.275v35.29h-2.275zm1.287-34.003v-.346l-.15-.149-.149.15v.345h.299zM81.49 26.78h-2.275v-9.85h12.16v18.288H89.1V19.217h-7.61zM42.643 60.222V43.933H62.71v16.289H42.643zm1.287-1.287h17.493V45.22H43.93v13.715zm-2.276 2.287V42.933H63.7v18.289H41.654zm1.287-1.287h19.47V44.22h-19.47v15.715z'
                }),
                _react2.default.createElement('path', {
                    d: 'M51.539 60.722V43.433h2.275v17.289H51.54zm1.138-.793l.149-.149v-.345h-.299v.345l.15.15zm.149-15.554l-.15-.15-.149.15v.345h.299v-.345zM71.606 72.722h-2.275v-29.79h18.09v29.79h-2.275V45.219h-13.54z'
                }),
                _react2.default.createElement('path', {
                    d: 'M79.215 60.722v-2.316h2.276v2.316zM93.054 86.163h2.275v29.49H33.747v-29.49h2.275v27.203h57.032z'
                }),
                _react2.default.createElement('path', {
                    d: 'M64.81 115.634h-2.275V95.186h15.867v20.448h-2.275V97.472H64.81zM58.841 106.767v2.287h-5.487v-4.017h-4.472v-4.314h-4.424v-4.315h-4.521V90.69h2.275v3.433h4.52v4.314h4.425v4.314h4.472v4.017z'
                }),
                _react2.default.createElement('path', {
                    d: 'M78.236 101.706v.644h-.688l-.263-2.287H78.214c1.453-.006 2.038-.047 2.476-.217.37-.146.507-.34.507-1.016V77.935h2.275V98.83c0 1.543-.669 2.644-1.956 3.146-.795.31-1.569.374-3.28.374v-.644z'
                }),
                _react2.default.createElement('path', {
                    d: 'M77.446 105.796h3.952c3.248 0 5.895-2.677 5.895-5.971V78.13h2.275v21.694c0 4.552-3.663 8.258-8.17 8.258h-3.952v-2.287zM34 83.64V81h2.275v2.64zM93.054 83.803v-2.64h2.275v2.64z'
                })
            )
        )
    );
};

FurnaceIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var Furnace = function (_React$Component) {
    _inherits(Furnace, _React$Component);

    function Furnace() {
        _classCallCheck(this, Furnace);

        return _possibleConstructorReturn(this, (Furnace.__proto__ || Object.getPrototypeOf(Furnace)).apply(this, arguments));
    }

    _createClass(Furnace, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(FurnaceIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return Furnace;
}(_react2.default.Component);

exports.default = Furnace;